import React from 'react'
import { Link } from 'react-router-dom'
import AppRoutes from '../../../routes/appRoutes'
import { Section } from '../../views/includes/Wrappers'
import L1NAdminLogo from '../../../../js/svg/L1N-admin-header-logo.svg'

const LogoHeader = () => (
    <section className="logo--section">
        <Section>
            <div className="logo">
                <Link to={AppRoutes.home()}>
                    <img
                        className="center h-18 w-62"
                        src={L1NAdminLogo}
                        alt="LiftOne Now"
                    />
                </Link>
            </div>
        </Section>
    </section>
)

export default LogoHeader
